export default __webpack_public_path__ + "b333cb8a30d0ec6a877809cc2f0221b6.svg";